import { apiClient } from '@/utils/httpClient';
import type { McpOAuthParams } from '@/utils/mcpOAuth';

export type McpOAuthCodeResponse = {
  code: string;
  state: string | null;
  expires_in: number;
  token_type: string;
};

export async function mintMcpOAuthCode(params: McpOAuthParams): Promise<McpOAuthCodeResponse> {
  return apiClient.post<McpOAuthCodeResponse>('/mcp/oauth/code', {
    client_id: params.clientId,
    redirect_uri: params.redirectUri,
    code_challenge: params.codeChallenge,
    code_challenge_method: params.codeChallengeMethod,
    state: params.state,
  });
}
